import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
import {
    parseStatus
} from "@/util/util";
import {
    baseUrl
} from '@/config/env';


export const projectItemOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "工程项目名称",
            prop: "name",
            type: 'select',
            span: 13,
            placeholder: '请选择客户端类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData: DIC.TAGS_CLIENT_TYPE,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择客户端类型"
            }],
        },
        {
            label: "关联服务商",
            prop: "company",
            type: 'input',
            span: 13,
            hide: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入标签名称"
            }],
            formatter: function (row, value, label, column) {
                if (row.company == null) {
                    if (row.agentId == '0') {
                        let str = '社区'
                        return str
                    }
                }
                return row.company
            }
        },
        {
            label: "预约渠道",
            prop: "clientType",
            type: 'input',
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                if (row.clientType) {
                    let list = row.clientType.split(',');
                    var result = "";
                    var index = 0;
                    for (let i of list) {
                        result += parseStatus(DIC.SERVICEITEM_TYPE, i);
                        if (index < list.length - 1) {
                            result += ',';
                        }
                        index++;
                    }
                    // return result;
                    return result
                }
            }
        },
        {
            label: "工程阶段数",
            prop: "num",
            type: 'input',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "工程项目名称",
            search: true,
            prop: "engineeringProjectName",
            type: 'input',
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};